import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';
import './styled/helper.css';

type Props = {
  current: number,
  totalSteps: number,
  tourSteps: any[],
  close: { (): void },
  gotoStep: { (): void },
  handleOnPrev: { (): void },
  handleOnNext: { (): void },
}

const Helper = ({
  current,
  tourSteps,
  totalSteps,
  close,
  gotoStep,
  handleOnPrev,
  handleOnNext,
}: Props) => {
  const {
    step,
    content,
  } = tourSteps[current];
  const {
    title,
    main,
  } = content();
  const body = {
    __html: main,
  };
  return (
    <S.Main>
      <S.Header>
        <S.HeaderContent>
          {title}
        </S.HeaderContent>
      </S.Header>
      <S.ContentWrapper>
        <S.Content>
          <span dangerouslySetInnerHTML={body} />
        </S.Content>
      </S.ContentWrapper>
      <S.ButtonWrapper>
        <Flex flex="0 0 60px">
          {current > 0 && (
            <Button
              appearance="primary"
              onClick={() => {
                gotoStep(current - 1);
                handleOnPrev(tourSteps[current - 1].step);
              }}
            >
              Prev
            </Button>
          )}
        </Flex>
        <S.List>
          {tourSteps.map((item, i) => (
            <S.ListItem key={`${item.step}_${Number(i)}`}>
              <S.ListIcon
                isCurrent={(i === current)}
              />
            </S.ListItem>
          ))}
        </S.List>
        {
          current === totalSteps - 1
            ? (
              <Button
                appearance="success"
                onClick={() => {
                  handleOnNext(step);
                  close();
                }}
              >
                Finish
              </Button>
            )
            : (
              <Button
                appearance="primary"
                onClick={() => {
                  gotoStep(current < totalSteps - 1 ? current + 1 : 0);
                  handleOnNext(step);
                }}
              >
                Next
              </Button>
            )
        }
      </S.ButtonWrapper>
    </S.Main>
  );
};

export default Helper;
